var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BalanceHistoryTableUser',{attrs:{"filterGetParams":_vm.filterGetParams,"countFilterParams":_vm.countFilterParams,"PAYMENT_HISTORY_TYPE":_vm.PAYMENT_HISTORY_TYPE},on:{"filter":_vm.filter,"changeFilter":_vm.changeFilter,"showMore":_vm.showMore,"resetFilter":_vm.resetFilter,"downloadFiles":_vm.downloadFiles}})
}
var staticRenderFns = []

export { render, staticRenderFns }